/**
 * Intersection Observer triggers
 * helper function to add classnames to elements when in viewport
 * 
 * @param animatableElemsArray {array} array of elements to observe
 * @param threshold {int} - how much of the entry should be in viewport
 * @param rootmargin {string} - rootmargin property for intersection config
 */
 export default function intersectionObserverTriggers(animatableElemsArray, threshold, rootmargin) {

    const intersectionOptions = {
        threshold: threshold,
        rootMargin: rootmargin, // ie. "60px 0px 0px 0px"
    };

    var intersectionHandler = function (entries, observer) {
        entries.forEach((entry) => {
            entry.target.classList.toggle("-in-view", entry.isIntersecting);
            if (entry.isIntersecting) {
              observer.unobserve(entry.target);
            }    
        });
    };

    let observer = new IntersectionObserver(
        intersectionHandler,
        intersectionOptions
    );
    animatableElemsArray.forEach((i) => {
        if (i) {
            observer.observe(i);
        }
    });

}